import { render, staticRenderFns } from "./MeesageAdd.vue?vue&type=template&id=1e5d6bb5&scoped=true&"
import script from "./MeesageAdd.vue?vue&type=script&lang=js&"
export * from "./MeesageAdd.vue?vue&type=script&lang=js&"
import style0 from "./MeesageAdd.vue?vue&type=style&index=0&id=1e5d6bb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5d6bb5",
  null
  
)

export default component.exports